<template>
    <div id="sidebar">
        <div class="r-sidebar-header">
            <router-link class="r-sidebar-item" :to="{name: 'Dashboard'}">
                <div class="r-sidebar-image">

                </div>
                <div class="r-ml-10 r-inline-grid">
                    <p class="r-ellipsis"><strong>Hi, {{user.name}} </strong></p>
                    <p>{{user.role_label}}</p>
                </div>
            </router-link>
        </div>
        <div class="r-sidebar-body">
            <div class="r-sidebar-items" 
                v-for="(s,i) in activeRoute" :key="`sidebar-${i}`">
                <router-link class="r-sidebar-item" :to="r.route" 
                    v-for="(r,j) in s.routes" :key="`${i}-sRoutes-${j}`" 
                    @mouseenter="hoverRoute = `${i}-sRoutes-${j}`"
                    @mouseleave="hoverRoute = null"
                    >
                    <img class="r-mr-10"
                        :src="require(`@/assets/icons/${isActiveSidebar(r, `${i}-sRoutes-${j}`) ? 'primary' : 'black'}/${r.icon}.svg`)">
                    <!-- <span :class="r.class">{{r.icon}}</span>  -->
                    <span class="r-ellipsis r-sidebar-label">{{r.label}}</span>
                </router-link>
            </div>
        </div>
        <div class="r-sidebar-logout">
            <router-link class="r-sidebar-item" :to="{name: 'Logout'}">
                <img 
                    class="r-mr-10"
                    :src="require('@/assets/icons/error/logout.svg')" alt="logout">
                <span>Logout</span>
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            user: 'auth/getUser'
        }),
        activeRoute(){
            const role = this.user.role
            return this.sidebar.map(x => {
                return {
                routes: x.routes.filter(y => 
                    (y.roles.some(z => z == role) || y.roles.length == 0))
                }
            }).filter(x => x.routes.length > 0)
        }
    },
    data: () => ({
        hoverRoute: null,
        sidebar: [
            {
                routes: [
                    {
                        route: {name: 'Dashboard'},
                        label: 'Beranda',
                        icon: 'category',
                        class: 'material-icons',
                        meta: 'Dashboard',
                        roles: []
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'UnitData'},
                        label: 'Data Unit',
                        icon: 'home',
                        class: 'material-icons',
                        meta: 'UnitData',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'SchoolYear'},
                        label: 'Daftar Tahun Ajaran',
                        icon: 'time_square',
                        class: 'material-icons',
                        meta: 'SchoolYear',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'Teacher'},
                        label: 'Data Guru',
                        icon: 'profile',
                        class: 'material-icons',
                        meta: 'Teacher',
                        roles: ['admin', 'staff']
                    },
                    {
                        route: {name: 'ClassRoom'},
                        label: 'Data Kelas',
                        icon: 'star',
                        class: 'material-icons',
                        meta: 'ClassRoom',
                        roles: ['admin', 'staff']
                    },
                    {
                        route: {name: 'ClassRoom'},
                        label: 'Daftar Kelas',
                        icon: 'star',
                        class: 'material-icons',
                        meta: 'ClassRoom',
                        roles: ['teacher']
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'Parent'},
                        label: 'Data Orang Tua',
                        icon: '3_user',
                        class: 'material-icons',
                        meta: 'Parent',
                        roles: ['admin', 'staff']
                    },
                    {
                        route: {name: 'Student'},
                        label: 'Data Siswa',
                        icon: '2_user',
                        class: 'material-icons',
                        meta: 'Student',
                        roles: ['admin', 'staff']
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'EducationSubject', params: {education_subject_type: 'mata-pelajaran'}},
                        label: 'Daftar Mata Pelajaran',
                        icon: 'paper',
                        class: 'material-icons',
                        meta: 'EducationSubject',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'EducationSubject', params: {education_subject_type: 'ekstrakulikuler'}},
                        label: 'Daftar Ekstrakulikuler',
                        icon: 'game',
                        class: 'material-icons',
                        meta: 'EducationSubject',
                        roles: ['admin']
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'ClassRoomReport'},
                        label: 'Nilai Rapor Siswa',
                        icon: 'chart',
                        class: 'material-icons',
                        meta: 'ClassRoomReport',
                        roles: ['teacher']
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'WebManagement'},
                        label: 'Manajemen Web Sekolah',
                        icon: 'work',
                        class: 'material-icons',
                        meta: 'WebManagement',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'Admission'},
                        label: 'Penerimaan Siswa Baru',
                        icon: 'add_user',
                        class: 'material-icons',
                        meta: 'Admission',
                        roles: ['admin', 'staff']
                    },
                    {
                        route: {name: 'Article', params: {article_type: 'pengumuman'}},
                        label: 'Pengumuman',
                        icon: 'bookmark',
                        class: 'material-icons',
                        meta: 'Article',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'BlogCategory'},
                        label: 'Kategori Blog',
                        icon: 'discovery',
                        class: 'material-icons',
                        meta: 'BlogCategory',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'Article', params: {article_type: 'blog'}},
                        label: 'Blog',
                        icon: 'edit',
                        class: 'material-icons',
                        meta: 'Article',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'Article', params: {article_type: 'prestasi'}},
                        label: 'Prestasi',
                        icon: 'ticket_star',
                        class: 'material-icons',
                        meta: 'Article',
                        roles: ['admin']
                    },
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'FileLayout'},
                        label: 'Manajemen Media',
                        icon: 'folder',
                        class: 'material-icons',
                        meta: 'FileLayout',
                        roles: ['admin']
                    },
                    
                ],
            },
            {
                routes: [
                    {
                        route: {name: 'Operator'},
                        label: 'Daftar Operator',
                        icon: 'shield_done',
                        class: 'material-icons',
                        meta: 'Operator',
                        roles: ['admin']
                    },
                    {
                        route: {name: 'AccountSetting'},
                        label: 'Pengaturan Akun',
                        icon: 'setting',
                        class: 'material-icons',
                        meta: 'AccountSetting',
                        roles: ['admin', 'staff', 'teacher']
                    },
                    {
                        route: {name: 'Faq'},
                        label: 'Faq',
                        icon: 'shield_done',
                        class: 'material-icons',
                        meta: 'Faq',
                        roles: ['admin']
                    },
                ],
            },
        ]
    }),
    methods: {
        isActiveSidebar(r, j){
            const route = r.route
            return this.$route.name == route.name && JSON.stringify(this.$route.params) == (JSON.stringify(route.params) || '{}') || this.hoverRoute == j
        }
    }
}
</script>